<template>
  <div class="retail-product-list">
    <XR-search-head class="product-list-head" mode="list" :key="this.$route.query.key"></XR-search-head>
    <v-scrollEvent :on-refresh="onRefresh" :on-infinite="onInfinite" :on-scrollEvent="scrollEvent" ref="scroll">
    <div class="sort-list" v-if="!loaded">
      <div :class="searchInfo.sort=='normal'?'sort-item select' :'sort-item' " @click="sortClick('normal')">
        <span>新品</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div :class="searchInfo.sort=='salecount'?'sort-item select' :'sort-item'" @click="sortClick('salecount')">
        <span>销量</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div :class="searchInfo.sort=='price'?'sort-item select' :'sort-item'" @click="sortClick('price')">
        <span>价格</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div :class="searchInfo.sort=='shop'?'sort-item select' :'sort-item'" @click="sortClick('shop')">
        <span>店铺</span>
        <i :class="'fa '+ sortIcon"></i>
      </div>
      <div class="sort-item sort-more" @click="open('right')">筛选</div>
      <mu-popup position="right" popupClass="retailproductlistCondition-popup" :style="{height:fullHeight+'px'}" :open="rightPopup" @close="close('right')">
        <div class="conditon-list" :style="{height: fullHeight-46+'px'}">
          <div class="retailproductlistcondition-title">          
            <div class="text">特色服务</div>
          </div>
          <div class="retailproductlistcondition-list">
            <div :class="'retailproductlistcondition-item ' + (this.searchInfo.isStock?'select':'')" @click="conditionService('stock')">仅看有货</div>
            <div :class="'retailproductlistcondition-item ' + (this.searchInfo.isDiscount?'select':'')" @click="conditionService('discount')">优惠</div>
            <div :class="'retailproductlistcondition-item ' + (this.searchInfo.isSelfPickUp?'select':'')" @click="conditionService('selfPickUp')">自提</div>
          </div>
          <div class="retailproductlistcondition-title">          
            <div class="text">属性搜索</div>
          </div>
          <mu-divider class="retailproductlistcondition-line" />

          <template v-for="attrItem in attrListResult">
            <div class="retailproductlistcondition-title">
              <div class="text">{{attrItem.AttrName}}</div>
              <div class="btn" @click="conditionBtnClick(attrItem.AttrId)"><i :class="currentAttrId == attrItem.AttrId? sizeBtnIcon: 'fa fa-angle-down'"></i></div>
            </div>
            <div class="retailproductlistcondition-list" :style="{height: getAttrHeight(attrItem.AttrId)}">
              <div :class="'retailproductlistcondition-item '+ getConditionCheckClassName(attrItem.AttrId,valueItem.AttrValueId)" @click="conditionValueClick(attrItem.AttrId,valueItem.AttrValueId)" v-for="valueItem in attrItem.AttrValueList">
                {{valueItem.AttrValue}}
              </div>
            </div>
            <mu-divider class="retailproductlistcondition-line" />
            
          </template>
        </div>
        <div class="condition-button">
          <div class="cbutton condition-reset" @click="resetCondition('right')">重置</div>
          <div class="cbutton condition-yes" @click="conditionSearch('right')">确定</div>
        </div>
      </mu-popup>
    </div>
  
    <div style="width:100%;height:auto;line-height:100%" v-if="bannerImg"><img :src="bannerImg" style="width:100%;height:auto;"></div>
    <div class="louceng" v-if="FloorName" style="margin-top:-3px;">
	  <div class="loucengLeft"><img src="/static/retail/lcs.png"></div>
	  <div class="loucengMiddle">{{FloorName}}</div>
	  <div class="loucengRight"><img src="/static/retail/lcs.png"></div>
	</div>
	
	
        <div class="pro-list" v-if="!loaded && this.searchInfo.sort != 'shop'">    
            <div v-for="(pItem, index) in productList" :key="pItem.SkuId">
                <div :class="'item '+ (index%2==0?'marginright':'')" :style="{width:itemWidth+'px'}" :key="pItem.SkuId">
                    <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
					<div class="productimg" :style="{height:itemWidth+'px'}">
                        <img :src="pItem.DefaultImg?pItem.DefaultImg: IMGServer_URL+'/images/index-item-default.png'" class="tj-pro-img" :style="{height:itemWidth+'px'}">
						<img class="productTag" v-if="pItem.Tag" :src="'/static/tag/' + pItem.Tag + '.png'" />
					</div>
                    </router-link>
                    <div class="price">
                        <p>￥<span class="money">{{pItem.PriceName}}</span></p>
                        <span class="del">￥{{pItem.MarketPrice}}</span>
                    </div>
                    <div class="name">{{pItem.ProductName}}</div>
                </div>
            </div>  
        </div>
	
	<!--
	<div class="newproduct-list" :style="'width:' + proListWidth + 'px'" v-if="!loaded && this.searchInfo.sort != 'shop'">
	  <div class="newproduct-item" v-for="(pItem,index) in productList" :key="pItem.SkuId">
	  <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
		<div :style="(index%2==0?'margin-right':'margin-left') + ':5px;height:' + proItemHeight + 'px'">
			<div class="productimg" :style="'width:100%;height:'+proItemImgWidth+'px'">
			  <img class="product" :src="pItem.DefaultImg?pItem.DefaultImg: IMGServer_URL+'/images/index-item-default.png'" />
			  <img class="productTag" v-if="pItem.Tag" :src="'/static/tag/' + pItem.Tag + '.png'" />
			</div>
			<div class="price"><span class="tag" v-if="pItem.IsDiscount==0">特卖价</span><span class="tag" v-if="pItem.IsDiscount>0">券后价</span><span class="saleprice" v-if="pItem.PriceName == '即将上架'" style="padding-left:10px;">即将上架</span><span class="saleprice" v-if="pItem.PriceName != '即将上架'">￥{{parseInt(pItem.PriceName)}}</span><span class="del" v-if="pItem.PriceName != '即将上架'">￥{{parseInt(pItem.MarketPrice)}}</span><span class="zhe" v-if="pItem.PriceName != '即将上架' && pItem.MarketPrice > 0">{{(pItem.Price * 10 / pItem.MarketPrice).toFixed(1)}}折</span></div>
			<div class="name">{{pItem.ProductName}}</div>
			<div class="name2" v-if="pItem.SellingPoint">{{pItem.SellingPoint}}</div>
			<div class="end">
				<span class="juan" v-if="pItem.IsDiscount>0">券￥{{pItem.baw}}</span>
				<span class="logo" v-if="pItem.IsDiscount==0"><span><img :src="pItem.Logo?pItem.Logo:siteInfo.Icon"></span><div>{{pItem.ShopName.substring(0,9)}}</div></span>
			</div>
		</div>
	  </router-link>     
	  </div>
	</div>
	-->
	
    <!--
    <div class="product-list" v-if="!loaded && this.searchInfo.sort != 'shop'">
      <div class="product-item" v-for="pItem in productList" :key="pItem.SkuId">
        <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
          <img :src="pItem.DefaultImg?pItem.DefaultImg: IMGServer_URL+'/images/index-item-default.png'" class="pro-img" />
          <div class="product-info" :style="{ width:proItemInfoWidth+'px'}">
            <p class="product-name">{{pItem.ProductName}}</p>
            <div class="active">            
              <p class="fontIcon integral" v-if="pItem.IsExchange>0">兑</p>
              <p class="fontIcon discount" v-if="pItem.IsDiscount>0">惠</p>              
            </div>
            <p class="shopInfo">
              <i class="fa fa-house1"></i> {{pItem.ShopName}}
            </p>
            <div class="saleinfo">
              <p class="price"><i class="fa fa-rmb"></i>{{pItem.PriceName}}</p>     
              <p class="saleCount">已售{{pItem.SaleCount}}</p>
            </div>
          </div>      
        </router-link>           
      </div>   
    </div>
	-->
    <div class="shop-list" v-if="!loaded && this.searchInfo.sort == 'shop'">
      <template v-for="sItem in shopList" >
        <router-link :to="'/shop/shopIndex?shopId='+sItem.ShopId" :key="sItem.ShopId">
          <div class="entrance">
            <div class="enceimg">
              <img :src="sItem.ShopLogo?sItem.ShopLogo:siteInfo.Icon" alt="">
            </div>
            <div class="store">
              <p class="storeName">{{sItem.ShopName}}</p>
              <p style="font-size:12px; color:#999;">{{sItem.ShopAreaName}}</p>
            </div>
            <div class="jian">
              <i class="fa fa-angle-right"></i>
            </div>
          </div>
        </router-link>        
        <div class="pro-list" :style="{height: prolistHeight+'px'}">          
            <div class="item-left" :style="{height: itemleftHeight+'px'}" v-for="pItem2 in sItem.ProductList" :key="pItem2.SkuId">               
              <router-link :to="'/retail/productDetail?skuId='+pItem2.SkuId" :key="sItem.ShopId">
                <img  :src="pItem2.DefaultImg?pItem2.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" :style="{height: imgHeight+'px'}" class="pro-img" />                   
              </router-link>   
              <div class="rmb">
                <span class="fa fa-rmb">{{pItem2.PriceName}}</span>
              </div>  
            </div>
        </div>    
      </template>
    </div>

    <div>
      <template v-if="hasData">
        <div class="qq_footer"><img class="jd_logo" id="jdBtmLogo" src=" ../static/refresh/more.png" />亲，暂无更多产品</div>
      </template>
      <template v-if="!loadData && !hasData">
          <div class="s_null" id="sNull01">
           <img style="width:30%;" src=" ../static/refresh/nomore.png" alt=""> 
            <p class="tip">亲，暂无更多产品！</p>
        </div>
      </template>
    </div>
    </v-scrollEvent>
    <mu-back-top>
      <mu-float-button icon=":fa fa-arrow-up" primary class="demo-float-button"/>
    </mu-back-top>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: true,
      rightPopup: false,
	  itemWidth: document.documentElement.clientWidth * 0.49,
      Width: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-125),
	  proListWidth: (parseInt(document.documentElement.clientWidth)),
	  proItemImgWidth: ((parseInt(document.documentElement.clientWidth)-40) / 2),
	  proItemHeight: ((parseInt(document.documentElement.clientWidth)-40) / 2) + 32 + 18 + 18 + 40 + 5,
      currentAttrId:0,
      sizeHeight : '102px',
      sizeBtnIcon: 'fa fa-angle-down',
      sortIcon: 'fa-angle-down',
	  bannerImg: this.$route.query.bannerImg?this.$route.query.bannerImg:'',
	  FloorName: this.$route.query.FloorName?this.$route.query.FloorName:'',
      searchInfo:{
        key: this.$route.query.searchKey?this.$route.query.searchKey:'',
        categoryId: this.$route.query.categoryId?this.$route.query.categoryId:0,
        sort: window.localStorage.productList_sort? window.localStorage.productList_sort : 'normal',
        orderBy: window.localStorage.productList_sortOrderBy?window.localStorage.productList_sortOrderBy:true,
        isStock : false,
        isDiscount: false,
        isSelfPickUp:false,
        brandIds : [],
        attrList: [],
        pageIndex:1
      },
      num:15,
      productList:[],
      shopList:[],
      attrListResult:[],
      pageEnd:0,
      scrollDone: function(){},
      hasData:false,
      loadData: true,
      siteInfo:[],
      
    }
  },
  mounted: function() {
    if(this.searchInfo.sort == 'shop'){
      this.shopSearch(true)
    }else{
      this.search(true)
    }
    this.getSiteInfo()
  },
  methods: {
    open (position) {
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    },
    conditionSearch(position){
      this.close(position)
      this.searchInfo.sort = "normal"
      this.search(true)
    },
    resetCondition(position){
      this.close(position)
      this.searchInfo.isStock = false
      this.searchInfo.isDiscount = false
	  this.searchInfo.isSelfPickUp = false
      this.searchInfo.attrList = []
      this.search(true)
    },
    conditionService(type){
      if(type == 'stock'){
        this.searchInfo.isStock = !this.searchInfo.isStock
      }else if(type=='selfPickUp'){
        this.searchInfo.isSelfPickUp = !this.searchInfo.isSelfPickUp
      }else{
        this.searchInfo.isDiscount = !this.searchInfo.isDiscount
      }
    },
    getAttrHeight(id){
      return this.currentAttrId == id? this.sizeHeight: 'unset'
    },
    conditionBtnClick (id){
      if(this.currentAttrId != id){
        this.sizeHeight = 'unset'
        this.sizeBtnIcon = 'fa fa-angle-down'
      }
      
      this.currentAttrId = id 
      if(this.sizeHeight == 'unset'){        
        this.sizeHeight = '102px'
        this.sizeBtnIcon = 'fa fa-angle-up'
      }else{        
        this.sizeHeight = 'unset'
        this.sizeBtnIcon = 'fa fa-angle-down'
      }
    },
    sortClick(key){
      if(this.searchInfo.sort == key){
        this.searchInfo.orderBy = !this.searchInfo.orderBy
      }
      else{
        this.searchInfo.sort = key
        this.searchInfo.orderBy = true
      }
      
      window.localStorage.productList_sort = this.searchInfo.sort
      window.localStorage.productList_sortOrderBy = this.searchInfo.orderBy

      this.sortIcon = this.searchInfo.orderBy ? 'fa-angle-down':'fa-angle-up'

      if(this.searchInfo.sort == 'shop'){
        this.shopSearch(true)
      }else{
        this.search(true)
      }
    },
    search:function(isNewSearch){
      this.$refs.XRtoast.load()
      var ths = this;  

      if(isNewSearch){        
        this.searchInfo.pageIndex = 1
      }
      else{
        this.searchInfo.pageIndex++
      }
      
      var url = '/Shop/RetailServer/SearchCategoryProduct';
      if(ths.searchInfo.key){
        url = '/Shop/RetailServer/SearchKeyProduct'
      }
      ths.$post(
        url,
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded =false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.loadData = false
          ths.productList=[]
          if(ths.productList.length == 0){
            ths.hasData= false
          }else{
            ths.hasData= true
          }
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.searchComplate(isNewSearch,res.Data)
        }
      });
    },    
    searchComplate(isNewSearch,data){

      this.attrListResult = data.AttrList
      if(isNewSearch){
        this.productList = data.ProductList.List
      }
      else{        
        for(var i=0; i< data.ProductList.List.length; i++){
          this.productList.push(data.ProductList.List[i])
        }
      }
      this.pageEnd = data.ProductList.Rows % this.num !=0 ? parseInt(data.ProductList.Rows / this.num)+1:data.ProductList.Rows/ this.num
      if(this.pageEnd == this.searchInfo.pageIndex){
         this.hasData = true
        //this.$refs.scroll.infiniteDone()
      }
      this.$refs.XRtoast.hide()
    },
    shopSearch:function(isNewSearch){
      this.$refs.XRtoast.load()
      var ths = this;  
      if(isNewSearch){     
        this.searchInfo.pageIndex = 1
      }
      else{
        this.searchInfo.pageIndex++
      }   
      var url = '/Shop/RetailServer/SearchShopProductList';
      ths.$post(
        url,
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded =false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shopSearchComplate(isNewSearch,res.Data)
        }
      });
    },    
    shopSearchComplate(isNewSearch,data){
      if(isNewSearch){
        this.shopList = data.List
      }
      else{        
        for(var i=0; i< data.List.length; i++){
          this.shopList.push(data.List[i])
        }
      }
      this.pageEnd = data.Rows% this.num!=0? data.Rows/ this.num+1:data.Rows/ this.num
      this.$refs.XRtoast.hide()
    },
    getConditionCheckClassName(attrId, attrValueId){
      for(var i = 0; i < this.searchInfo.attrList.length;i++){
        var attrItem = this.searchInfo.attrList[i]
        if(attrItem.attrId == attrId && attrItem.attrValueId == attrValueId){
          return 'select'
        }
      }
      return ''
    },
    conditionValueClick(attrId, attrValueId){
      if(this.searchInfo.attrList.length==0){
        this.searchInfo.attrList.push({attrId:attrId, attrValueId:attrValueId})
        return
      }
      var attrList = []
      var currentAttr = {}
      for(var i = 0; i < this.searchInfo.attrList.length;i++){
        var attrItem = this.searchInfo.attrList[i]
        if(attrItem.attrId != attrId){
          attrList.push(attrItem)
        }else {
          currentAttr = attrItem
        }
      }

      if(currentAttr.attrValueId != attrValueId){
        attrList.push({attrId:attrId, attrValueId:attrValueId})
      }
      this.searchInfo.attrList = attrList
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到底",true)
        this.$refs.scroll.infiniteDone()
        return
      }
      if(this.searchInfo.sort == 'shop'){
        this.shopSearch(false)
      }else{
        this.search(false)
      }
    },
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }    
  },
  computed: {
    prolistHeight:function(){
      return this.Width * 0.3+this.Width* 0.06      
    },
    imgHeight:function(){
      return this.Width * 0.94 * 0.33 * 0.9
    },
    itemleftHeight:function(){
      return this.Width * 0.3
    },
    leftWidth:function(){
      return (this.itemleftHeight-60)/2
    
    }
    
  }
};
</script>

<style>
 .retail-product-list #sNull01{
   text-align: center;
   padding: 10px;
   padding-top: 40px;
    color: #999;
    height: 195px;
 }
 .retail-product-list .louceng{
   display: flex;
   -webkit-box-pack: center;
   justify-content: center;
   -webkit-box-align: center;
   align-items: center;
   padding-top:8px;
   padding-bottom:8px;
   background:#fff;
 } 
 .retail-product-list .louceng .loucengMiddle{
   font-size:16px;
   color:#343434;
   margin-left:5px;
   margin-right:5px;
 }
 .retail-product-list .newproduct-list{
   overflow: hidden;
   width:100%;
   height:auto;
   padding-left:20px;
   padding-right:20px;
   background:#fff;
 }
 .retail-product-list .newproduct-list .newproduct-item{
   float:left;
   width:50%;
 }
 .retail-product-list .newproduct-list .newproduct-item .productimg{
   width:100%;
   position: relative;
 }
 .retail-product-list .newproduct-list .newproduct-item .productimg img.product{
   position: absolute;
   width:100%;
   height:100%;
   top:0px;
   left:0px;
   z-index:10;
 }
 .retail-product-list .newproduct-list .newproduct-item .productimg img.productTag{
   position: absolute;
   width:40%;
   height:auto;
   top:0px;
   left:0px;
   z-index:20;
 }
 .retail-product-list .newproduct-list .newproduct-item .price{
   width:100%;
   margin-top:8px;
   height:24px;
   overflow:hidden;
   display: inline-block;
   white-space: nowrap;
   text-overflow:ellipsis;
 }
 .retail-product-list .newproduct-list .newproduct-item .price .tag{
   width:auto;
   background:#FC498A;
   color:#fff;
   padding:3px;
   border-width: 1px;
   border-style: solid;
   border-radius: 3px;
   border-color: #FD4993;
 }
 .retail-product-list .newproduct-list .newproduct-item .price .saleprice{
   color:#484848;
   font-size:16px;
   font-weight:bold;
 }
 .retail-product-list .newproduct-list .newproduct-item .price .del{
   color:#C3C3C5;
   font-size:12px;
   text-decoration:line-through;
 }
 .retail-product-list .newproduct-list .newproduct-item .price .zhe{
   color:#C3C3C5;
   font-size:12px;
   padding-left:5px;
 }
 .retail-product-list .newproduct-list .newproduct-item .name{
   width:100%;
   height:18px;
   overflow:hidden;
   display: inline-block;
   white-space: nowrap;
   text-overflow:ellipsis;
   font-size:14px;
   color:#6F7075;
 }
 .retail-product-list .newproduct-list .newproduct-item .name2{
   width:100%;
   height:16px;
   overflow:hidden;
   display: inline-block;
   white-space: nowrap;
   text-overflow:ellipsis;
   font-size:12px;
   color:#B3B3B5;
 }
 .retail-product-list .newproduct-list .newproduct-item .end{
   width:100%;
   height:20px;
   margin-bottom:20px;
 }
 .retail-product-list .newproduct-list .newproduct-item .end .juan{
   width:auto;
   background:#F7E8EB;
   color:#DE5078;
   font-size:12px;
   padding:2px 5px 2px 5px;
   border-width: 1px;
   border-style: solid;
   border-radius: 3px;
   border-color: #FBF4F5;   
 }
 .retail-product-list .newproduct-list .newproduct-item .end .logo{
   width:auto;
   height:20px;
   display: inline-block;   
   background:#EDECF2;
   color:#9E95BE;
   font-size:12px;
   padding:2px 5px 2px 5px;
   border-width: 1px;
   border-style: solid;
   border-radius: 3px;
   border-color: #EDECF2;   
 }
 .retail-product-list .newproduct-list .newproduct-item .end .logo span{
   width:auto;
   height:16px;
   float:left;
   overflow:hidden;
 }
 .retail-product-list .newproduct-list .newproduct-item .end .logo span img{
   width:auto;
   height:14px;
   padding-right:8px;
   margin-top:1px;
 }
 .retail-product-list .newproduct-list .newproduct-item .end .logo div{
   float:left;
   overflow:hidden;
   white-space: nowrap;
   text-overflow:ellipsis;
   display:inline-block;
 }
 
.retail-product-list .pro-list {
  overflow: hidden;
}
.retail-product-list .pro-list .item {
  float: left;
  width: 49%;
  margin-bottom: 2%;
  background: white;
}
.retail-product-list .pro-list .item.marginright {
  margin-right: 2%;
}
.retail-product-list .pro-list .item .productimg{
  width:100%;
  position: relative;
}
.retail-product-list .pro-list .item .productimg img.tj-pro-img {
  position: absolute;
  width:100%;
  height:100%;
  top:0px;
  left:0px;
  z-index:10;
}
.retail-product-list .pro-list .item .productimg img.productTag{
  position: absolute;
  width:40%;
  height:auto;
  top:0px;
  left:0px;
  z-index:20;
}
.retail-product-list .pro-list .item .price {
  overflow: hidden;
  padding: 0 2%;
}
.retail-product-list .pro-list .item .price p {
  float: left;
  color: Red;
}
.retail-product-list .pro-list .item .price .money {
  font-size: 16px;
  color: red;
  margin-right: 10px;
}
.retail-product-list .pro-list .item .price .del {
  font-size: 12px;
  text-decoration: line-through;
  float: left;
  color: #7b7b7b;
  height: 24px;
  line-height: 24px;
}
.retail-product-list .pro-list .item .name {
  color: Black;
  margin: 2% 2% 8%;
  line-height: 14px;
  height: 40px;
  overflow: hidden;
  line-height: 20px;
}
 
 .retail-product-list .mu-appbar.XR-search-head.head{
   background: rgba(0,0,0)
 }
 .s_null .tip {
    margin-bottom: 15px;
    line-height: 1;
    font-size: 12px;
    color: #aaa;
    text-align: center;
}
.retail-product-list .mu-appbar .right .mu-icon-button>div{
  background: rgba(71, 74, 79, 0.3);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-align: center;
    padding-top: 3px;
}
.retail-product-list .mu-appbar .left .mu-icon-button>div{
  background: rgba(71, 74, 79, 0.3);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-align: center;
    padding-top: 2px;
}
.retail-product-list .sort-list{
  overflow: hidden;
  background: white;
}
.retail-product-list .sort-list .sort-item{
  overflow: hidden;
  line-height: 40px;
  width: 20%;
  text-align: center;
  float: left;
}
.retail-product-list .sort-list .sort-item .fa{
  display: none;
}
.retail-product-list .sort-list .sort-item.sort-more{
  width: 20%;
  float: right;
}
.retail-product-list .sort-list .sort-item.select{
  color:red;
}
.retail-product-list .sort-list .sort-item.select .fa{
  display: inline;
}
.retailproductlistCondition-popup{  
  width: 80%;
  height: 100%;
  max-width: 375px;
  align-items: center;
  padding: 10px;
}
.retailproductlistCondition-popup .retailproductlistcondition-line{  
  margin: 10px 0;
}
.retailproductlistCondition-popup .conditon-list{ 
  overflow-y: scroll;
}
.retailproductlistCondition-popup .retailproductlistcondition-title{ 
  overflow: hidden;
  padding-bottom: 10px;
}
.retailproductlistCondition-popup .retailproductlistcondition-title .text{ 
  float: left;
  color:black;
}
.retailproductlistCondition-popup .retailproductlistcondition-title .btn{ 
  float: right;
}
.retailproductlistCondition-popup .retailproductlistcondition-list{ 
  overflow: hidden;  
  height: 102px;
}
.retailproductlistCondition-popup .retailproductlistcondition-item{ 
  float: left;
  width:30%;
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 3.33%;
  margin-bottom: 10px;
  text-align: center;
  background: #F0F2F5;
  border-radius: 4px;
}
.retailproductlistCondition-popup .retailproductlistcondition-item.select{ 
  background: red;
  color:white;
}


.retail-product-list .product-list{
  overflow: hidden;
  margin-top: 5px;
  border-bottom:1px solid #eee;
  background: white;
}
.retail-product-list .product-list .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px 0;
  height: 136px;
}
.retail-product-list .product-list .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.retail-product-list .product-list .product-item a{  
  color:black;
}
.retail-product-list .product-list .product-item .pro-img{
  width: 105px;
  float: left;
  background: white;
  object-fit: cover;
  height: 105px;
}
.retail-product-list .product-list .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 85px;
}
.retail-product-list .product-list .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 20px;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  padding-bottom: 10px;
}

.retail-product-list .product-list .product-item  .product-info .active{
  overflow: hidden;
  height: 26px;
}
.retail-product-list .product-list .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  background: red;
  text-align: center;
  color:white;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 6px 1px;
}
.retail-product-list .product-list .product-item  .product-info .active .wua{
  width: 34px;
  height: 14px;
}

.retail-product-list .product-list .product-item  .shopInfo{
  overflow: hidden;
  line-height: 16px;
  height: 16px;
  font-size: 12px;
  margin-top: 4px;
  color: #666;
}
.retail-product-list .product-list .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
  margin-top: 10px;
}
.retail-product-list .product-list .product-item  .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  float: left;
  font-size: 16px;
  color:Red;
  padding-right: 10px;
}
.retail-product-list .product-list .product-item  .product-info .saleinfo .price .fa{
  font-size: 12px;
  margin-right: 5px;
}
.retail-product-list .product-list .product-item  .product-info .saleinfo .saleCount{
  float: right;
  color:#ccc;
}

.retail-product-list .XR-search-head .search-ctrl .input-ctrl{
  width: 85%;
}
.retail-product-list .shop-list{

}
.retail-product-list .shop-list .shop-item{
  
}
.retail-product-list .shop-list .shop-item .shop-info{
  
}
.retail-product-list .shop-list .shop-item .shop-product-list{
  
}
.retail-product-list .shop-list .shop-item .shop-product-list{
  overflow: hidden;
}
.retail-product-list .shop-list .shop-item .shop-product-list .shop-product-item{
  width:33.33%;
  float: left;
}
.retail-product-list .shop-list .shop-item .shop-product-list .shop-product-item .pro-img{
  width: 100%;
}
.retail-product-list .shop-list .shop-item .shop-product-list .shop-product-item .pro-price{
  
}

.retail-product-list .shop-list .entrance{
  margin-top: 10px;
  height: 64px;
  padding: 0 3%;
  width: 100%;
  background: #fff;
  align-items: center;
  display: flex;
  border-bottom: 1px solid #eee;
}
.retail-product-list .shop-list .enceimg{
  float: left;
  width: 60px;
  height: 60px;
  padding: 6px;
  display: flex;
  align-items: center;  
  justify-content: center;
}
.retail-product-list .shop-list .enceimg img{
  width: 100%;
  max-height: 100%;
  object-fit: cover;
}
.retail-product-list .shop-list .store{
  width: 70%;
  padding: 3% 3%;
  float: left;
}
.retail-product-list .shop-list .store .storeName{
  color: #000;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.retail-product-list .shop-list .jian{
  width: 10%;
  text-align: right;
  padding: 5% 0;
  float: left;
  color: #ccc;
}
.retail-product-list .shop-list .jian img{
  width: 15px;
  height: 10px;

}
.retail-product-list .shop-list .pro-list{
  overflow: hidden;
  width: 100%; 
  padding: 3% 3% 0 3%;
  background: #fff;
}
.retail-product-list .shop-list .pro-list .item-left{
  float: left;
  width: 33.3%;
  text-align: center;
  background-size: cover;
  position: relative;
}
.retail-product-list .shop-list .pro-list .item-left img{
  width: 90%;
  object-fit: cover;
}
.retail-product-list .shop-list .pro-list .item-left .rmb{
  position: absolute;
  bottom: 3px;
  left: 0;
  right: 0;
  margin: auto;
}
.retail-product-list .shop-list .pro-list .item-left .rmb span{
  background: rgba(241,149,0, 0.6);
  color: white;
  padding:  2px 4px;
  font-size: 14px;
  font-weight: bold;

}


.retailproductlistCondition-popup .condition-button{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  text-align: center;
  line-height: 46px;
}
.retailproductlistCondition-popup .condition-button .cbutton{
  float: left;
  width: 50%;
  border-top:1px solid #eee;
  background: white;
}
.retailproductlistCondition-popup .condition-button .condition-yes{
  background: red;
  border-top:1px solid #eee;
  color:white;
}
.retail-product-list .product-list{
  border:0;
}
  
  
 .s_empty {
    text-align: center;
    height: 100px;
    line-height: 100px;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/retail/newproductList.vue